import * as PIXI from "pixi.js";
import gsap from "gsap";

import ServiceLocator from "../../ServiceLocator";
import Session from "../../Session";
import Utils from "../../Utils";
import PlayerSlot from "./PlayerSlot";


export default class MatchmakingReadyAnim extends PIXI.Container
{
    private _arrPlayerSlot: Array<PlayerSlot> = null;

    private _bg: PIXI.Sprite = null;
    private _spotlight: PIXI.Sprite = null;
    private _arrTriangle: Array<PIXI.Sprite> = null;
    private _banner: PIXI.Sprite = null;
    private _bannerText: PIXI.Text = null;
    private _bannerSparksAnim: PIXI.AnimatedSprite = null;
    private _godrays: PIXI.Sprite = null;
    private _flash: PIXI.Sprite = null;
    private _flashSparksAnim: PIXI.AnimatedSprite = null;
    private _versus: PIXI.Sprite = null;

    private _gameReadyTl: gsap.core.Timeline = null;

    public constructor() { super(); }


    public set playerSlots( value: Array<PlayerSlot> ) { this._arrPlayerSlot = value; }


    public init(): void
    {
        console.assert( this._arrPlayerSlot != null, "MatchmakingReadyAnim.ts :: init() :: this._arrPlayerSlot cannot be null." );

        this._arrTriangle = [];

        this._bg = new PIXI.Sprite( ServiceLocator.resources.game_bg.texture );
        this._bg.visible = false;
        this._bg.anchor.set( 0.5 );
        this._bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._bg );
        //
        this._spotlight = new PIXI.Sprite( ServiceLocator.resources.spotlight.texture );
        this._spotlight.visible = false;
        this._spotlight.anchor.set( 0.5 );
        this._spotlight.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._spotlight );

        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let triangle: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "mm_" + [ "bottom", "left", "right", "top" ][ i ] + "_triangle" ].texture );
            triangle.visible = false;
            triangle.anchor.set( [ 0.5, 0, 1, 0.5 ][ i ], [ 1, 0.5, 0.5, 0 ][ i ] );
            triangle.position.set( 
                [ ServiceLocator.app.width * 0.5, -ServiceLocator.app.safeAreaMarginX, ServiceLocator.app.width + ServiceLocator.app.safeAreaMarginX, ServiceLocator.app.width * 0.5 ][ i ], 
                [ ServiceLocator.app.height + ServiceLocator.app.safeAreaMarginY, ServiceLocator.app.height * 0.5, ServiceLocator.app.height * 0.5, -ServiceLocator.app.safeAreaMarginY ][ i ] );
            this.addChild( triangle );
            
            this._arrTriangle.push( triangle );
        }

        this._banner = new PIXI.Sprite( ServiceLocator.resources.tut_header_base.texture );
        this._banner.visible = false;
        this._banner.anchor.set( 0.5 );
        this._banner.position.set( ServiceLocator.app.width * 0.5, 218 );
        this.addChild( this._banner );
        //
        this._bannerText = new PIXI.Text( "START!", { fontFamily: "asap_bold", fontSize: 80, fill: 0xffffdf } );
        this._bannerText.anchor.set( 0.5 );
        this._banner.addChild( this._bannerText );

        this._bannerSparksAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "mm_banner_sparks_", 6 ) ); 
        this._bannerSparksAnim.visible = false;
        this._bannerSparksAnim.loop = false;
        this._bannerSparksAnim.animationSpeed = 20;
        this._bannerSparksAnim.autoUpdate = false;
        this._bannerSparksAnim.anchor.set( 0.5 );
        this._bannerSparksAnim.position.copyFrom( this._banner.position );
        this.addChild( this._bannerSparksAnim );
        this._bannerSparksAnim.onComplete = () => { this._bannerSparksAnim.visible = false; };

        this._godrays = new PIXI.Sprite( ServiceLocator.resources.mm_godrays.texture );
        this._godrays.visible = false;
        this._godrays.anchor.set( 0.5 );
        this._godrays.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._godrays );

        this._flash = new PIXI.Sprite( ServiceLocator.resources.mm_flash.texture );
        this._flash.visible = false;
        this._flash.anchor.set( 0.5 );
        this._flash.position.copyFrom( this._godrays.position );
        this.addChild( this._flash );

        this._flashSparksAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "mm_flash_sparks_", 5 ) ); 
        this._flashSparksAnim.visible = false;
        this._flashSparksAnim.loop = false;
        this._flashSparksAnim.animationSpeed = 20;
        this._flashSparksAnim.autoUpdate = false;
        this._flashSparksAnim.anchor.set( 0.5 );
        this._flashSparksAnim.position.copyFrom( this._godrays.position );
        this.addChild( this._flashSparksAnim );
        this._flashSparksAnim.onComplete = () => { this._flashSparksAnim.visible = false; };

        this._versus = new PIXI.Sprite( ServiceLocator.resources.mm_vs.texture );
        this._versus.visible = false;
        this._versus.anchor.set( 0.5 );
        this._versus.position.copyFrom( this._flash.position );
        this.addChild( this._versus );
    }

    public play(): gsap.core.Timeline
    {
        ServiceLocator.audio.playSfx( "game_ready" );

        this._gameReadyTl = new gsap.core.Timeline();
        for ( let triangle of this._arrTriangle )
        {
            triangle.visible = true;
            this._gameReadyTl.from( triangle, { alpha: 0, duration: 0.8, ease: "sine.in" }, 0 );
        }  
        this._gameReadyTl.call( () => {
            this._bg.visible = true;
        }, null, 0.8 );
        this._banner.visible = true;
        this._gameReadyTl.from( this._banner.scale, { y: 0, duration: 0.6, ease: "back.out(2)" }, 0 );
        this._gameReadyTl.call( () => {
            this._bannerSparksAnim.visible = true;
            this._bannerSparksAnim.gotoAndPlay( 0 );
        }, null, 0.2 );
        this._godrays.visible = true;
        this._flash.visible = true;
        this._gameReadyTl.from( this._flash.scale, { x: 0, y: 0, duration: 0.6, ease: "back.out(2)" }, 0 );
        this._gameReadyTl.call( () => {
            this._flashSparksAnim.visible = true;
            this._flashSparksAnim.gotoAndPlay( 0 );
        }, null, 0.2 );
        this._gameReadyTl.call( () => { this._versus.visible = true; }, null, 0.2 );
        this._gameReadyTl.from( this._versus.scale, { x: 0, y: 0, duration: 0.6, ease: "back.out(2)" }, 0.2 );
        // Out sequence.
        this._gameReadyTl.call( () => {
            this._bannerText.anchor.x = 0;
            this._bannerText.position.copyFrom( this._banner.position );
            this._bannerText.x -= this._bannerText.width * 0.5;
            this.addChild( this._bannerText );

            this._banner.anchor.x = 1;
            this._banner.x = ServiceLocator.app.width + ServiceLocator.app.safeAreaMarginX;
        }, null );
        this._gameReadyTl.to( this._bannerText, { x: ServiceLocator.app.width + ServiceLocator.app.safeAreaMarginX, duration: 0.4, ease: "back.in" }, 2 );
        this._gameReadyTl.to( this._banner.scale, { x: 0, duration: 0.24, ease: "linear.inOut" }, 2.4 );
        this._gameReadyTl.to( this._godrays.scale, { x: 0, y: 0, duration: 0.24, ease: "sine.in" }, 2.64 );
        this._gameReadyTl.to( this._flash.scale, { x: 0, y: 0, duration: 0.2, ease: "sine.in" }, 2.64 );
        this._gameReadyTl.to( this._versus.scale, { x: 1.6, y: 1.6, duration: 0.6, ease: "sine.in" }, 2.64 );
        this._gameReadyTl.to( this._versus, { alpha: 0, duration: 0.2, ease: "sine.in" }, 3 );
        this._gameReadyTl.call( () => {
            let triangleIndex: number = 0;
            for ( let playerSlot of this._arrPlayerSlot )
            {
                playerSlot.position.copyFrom( this._arrTriangle[ triangleIndex ].toLocal( playerSlot.getGlobalPosition() ) );
                this._arrTriangle[ triangleIndex ].addChild( playerSlot );

                triangleIndex += 1;
            }
        }, null, 2.64 );
        const kTriangleOutSpeed: number = 1200;
        for ( let i: number = 0; i < this._arrTriangle.length; ++i )
        {
            switch ( i )
            {
                case 0: { this._gameReadyTl.to( this._arrTriangle[ i ], { y: "+=" + this._arrTriangle[ i ].height.toString(), duration: this._arrTriangle[ i ].height / kTriangleOutSpeed, ease: "linear.inOut" }, 2.64 ); break; }
                case 1: { this._gameReadyTl.to( this._arrTriangle[ i ], { x: "-=" + this._arrTriangle[ i ].width.toString(), duration: this._arrTriangle[ i ].width / kTriangleOutSpeed, ease: "linear.inOut" }, 2.64 ); break; }
                case 2: { this._gameReadyTl.to( this._arrTriangle[ i ], { x: "+=" + this._arrTriangle[ i ].width.toString(), duration: this._arrTriangle[ i ].width / kTriangleOutSpeed, ease: "linear.inOut" }, 2.64 ); break; }
                case 3: { this._gameReadyTl.to( this._arrTriangle[ i ], { y: "-=" + this._arrTriangle[ i ].height.toString(), duration: this._arrTriangle[ i ].height / kTriangleOutSpeed, ease: "linear.inOut" }, 2.64 ); break; }
            }
        }
        this._gameReadyTl.call( () => {  this._spotlight.visible = true; }, null, 3.4 );
        this._gameReadyTl.call( () => {  this._spotlight.visible = false; }, null, 3.6 );
        this._gameReadyTl.call( () => {  this._spotlight.visible = true; }, null, 3.7 );
        this._gameReadyTl.call( () => {  this._spotlight.visible = false; }, null, 3.8 );
        this._gameReadyTl.call( () => {  this._spotlight.visible = true; }, null, 3.9 );
        this._gameReadyTl.call( () => {}, null, 4.2 );

        return this._gameReadyTl;
    }

    public end(): void
    {
        if ( this._gameReadyTl )
        {
            this._gameReadyTl.kill();
            this._gameReadyTl = null;
        }
    }

    public update( dt: number ): void
    {
        if ( this._godrays.visible )
        {
            this._godrays.angle += dt * 45;
        }
        if ( this._bannerSparksAnim.visible )
        {
            this._bannerSparksAnim.update( dt );
        }
        if ( this._flashSparksAnim.visible )
        {
            this._flashSparksAnim.update( dt );
        }
    }
}